@use '../../scss/utility' as utility;
@use './load-more-vars';

:host {
  @include load-more-vars.wb-load-more-vars;

  display: inline-flex;
  flex-direction: column;
  align-items: center;

  @include utility.breakpoint-from(mq4) {
    @include load-more-vars.wb-load-more-desktop-vars;
  }
}

.wb-text {
  color: var(--load-more-progress-text-color);
  margin-block-end: var(--load-more-progress-gap);
}

.wb-progress {
  max-width: utility.wb-pixel-to-rem(120px);
  margin-block-end: var(--button-offset);
}
